import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'reactstrap';

import classnames from 'classnames';
import styles from './index.module.scss';

export class TabLinkV2 extends Component {
  static propTypes = {
    onClick: PropTypes.func,
    active: PropTypes.bool,
  };

  render() {
    const { onClick, className, active, ...other } = this.props;
    // pass a props of active as a boolean to trigger active class

    const defaultClasses = classnames(className, {
      [styles.active]: active,
      [styles.tabLink]: true,
    });

    return <NavLink className={defaultClasses} onClick={onClick} {...other} />;
  }
}

export default TabLinkV2;
